module.exports = __webpack_public_path__ + "static/media/introduction_for_supervision.c478bf67.png";